import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function C() {
    const { t } = useLang('bkw');
    return (
        <div id="bkw-C" className={`bkw-C bkw-box ${css['bkw-C']}`}>
            <EfSpec />
            <div className="img-box">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1738824389811/3.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1738824389627/3_M.jpg"
                />
                <div className="info">
                    <h2 className="title">
                        {t.rich('C_title', {
                            y: (tx: string) => <span className="y">{tx}</span>,
                        })}
                    </h2>
                    <p className="desc">{t('C_desc')}</p>
                </div>
            </div>
        </div>
    );
}
